/**
 * Cache prefixes for the two entities that write into each other's data. Confirming a period can
 * rewrite the template amount, and every action on a payment rewrites its periods (design note
 * D3) - so each one has to reach the other's branch when it invalidates.
 *
 * They live here, above both entities, because the alternative is an import in both directions
 * between two slices. The full factories with `queryOptions` stay in their own slices and build
 * on these prefixes, so a key can never drift between the two places.
 */
export const paymentQueryRoot = {
  all: () => ['payments'] as const,
  lists: () => [...paymentQueryRoot.all(), 'list'] as const,
  details: () => [...paymentQueryRoot.all(), 'detail'] as const,
};

export const occurrenceQueryRoot = {
  all: () => ['occurrences'] as const,
  lists: () => [...occurrenceQueryRoot.all(), 'list'] as const,
  details: () => [...occurrenceQueryRoot.all(), 'detail'] as const,
};

/**
 * The summary is a view over payments and periods alike, so every write to either one has to
 * reach it. It lives here for the same reason the two above do.
 */
export const summaryQueryRoot = {
  all: () => ['summary'] as const,
};

export const cardQueryRoot = {
  all: () => ['cards'] as const,
  lists: () => [...cardQueryRoot.all(), 'list'] as const,
};

export const categoryQueryRoot = {
  all: () => ['categories'] as const,
  lists: () => [...categoryQueryRoot.all(), 'list'] as const,
};

export const bankQueryRoot = {
  all: () => ['bank'] as const,
};

export const attentionQueryRoot = {
  all: () => ['attention'] as const,
};
